import React from 'react';

interface PanelProps {
  title?: string;
  description?: string;
  /** Right-aligned controls in the panel header: filters, links, buttons. */
  actions?: React.ReactNode;
  /** Removes body padding, for panels whose child is a full-bleed table. */
  flush?: boolean;
  className?: string;
  children: React.ReactNode;
}

/**
 * The console had three overlapping card classes (`.card`, `.admin-card`,
 * `.stats-card`) plus the same nine utility classes pasted inline in a dozen
 * places, so radius, padding and shadow drifted panel to panel. This is the
 * one container.
 */
const Panel: React.FC<PanelProps> = ({ title, description, actions, flush = false, className = '', children }) => (
  <section className={`overflow-hidden rounded-card border border-border-subtle bg-surface shadow-card ${className}`}>
    {title || actions ? (
      <header className="flex flex-wrap items-start justify-between gap-3 border-b border-border-subtle px-5 py-4">
        <div className="min-w-0">
          {title ? <h2 className="text-sm font-semibold text-ink">{title}</h2> : null}
          {description ? <p className="mt-0.5 text-xs leading-5 text-ink-3">{description}</p> : null}
        </div>
        {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
      </header>
    ) : null}
    <div className={flush ? '' : 'p-5'}>{children}</div>
  </section>
);

export default Panel;
